export enum AG_APPLICATIONS {
  PORTAL = 'Agent Portal',
  ARM = 'Agent Resource Manager',
  AWB = 'Agent Web Builder',
  ACB = 'Agent Campaigns Builder',
  Campaigns = 'Campaigns',
}
